export default function isUserAdmin(currentUser){
  return currentUser.uid === '62aSbsBw7LbF3R8JRvHHkvBX64z2'
}